(() => {
  if (window.mlStockAlertsLoaded) return;
  window.mlStockAlertsLoaded = true;

  const hydrateForms = (scope, variant = null) => {
    scope.querySelectorAll('[data-stock-alert-form]').forEach((form) => {
      const productForm = form.closest('.shopify-section, dialog')?.querySelector('product-form-component');
      const variantId = String(
        variant?.id ||
        productForm?.querySelector('input[name="id"]')?.value ||
        new URLSearchParams(window.location.search).get('variant') ||
        '',
      );
      const productId = String(productForm?.dataset.productId || '');
      const baseTitle = document.querySelector('h1')?.textContent?.trim() || document.title.split('|')[0].trim();
      const variantTitle = variant?.title && variant.title !== 'Default Title' ? ` — ${variant.title}` : '';
      const productPath = productForm?.dataset.productUrl || window.location.pathname;

      form.querySelector('input[name="productId"]')?.setAttribute('value', productId);
      form.querySelector('input[name="variantId"]')?.setAttribute('value', variantId);
      form.querySelector('input[name="productTitle"]')?.setAttribute('value', `${baseTitle}${variantTitle}`);
      form.querySelector('input[name="productUrl"]')?.setAttribute('value', `${window.location.origin}${productPath}?variant=${variantId}`);
      form.querySelector('input[name="locale"]')?.setAttribute('value', document.documentElement.lang || 'fr');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrateForms(document), {once: true});
  } else {
    hydrateForms(document);
  }

  document.addEventListener('variant:update', (event) => {
    const html = event.detail?.data?.html;
    const variant = event.detail?.resource;
    if (!html || !variant) return;
    const scope = event.target instanceof Element
      ? event.target.closest('.shopify-section, dialog') || document
      : document;

    scope.querySelectorAll('[data-stock-alert-slot]').forEach((slot) => {
      const id = slot.dataset.stockAlertId;
      const updated = html.querySelector(`[data-stock-alert-id="${CSS.escape(id)}"]`);
      if (updated) slot.replaceChildren(...Array.from(updated.childNodes, (node) => node.cloneNode(true)));
    });

    hydrateForms(scope, variant);

    scope.querySelectorAll('[data-coming-soon-product-badge]').forEach((badge) => {
      badge.hidden = variant.available !== false;
    });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-stock-alert-form]');
    if (!form) return;
    event.preventDefault();

    const status = form.querySelector('[data-stock-alert-status]');
    const button = form.querySelector('button[type="submit"]');
    const data = Object.fromEntries(new FormData(form));
    const productForm = form.closest('.shopify-section, dialog')?.querySelector('product-form-component');
    const selectedVariantId = String(
      productForm?.querySelector('input[name="id"]')?.value ||
      new URLSearchParams(window.location.search).get('variant') ||
      data.variantId ||
      '',
    );
    const productPath = productForm?.dataset.productUrl || window.location.pathname;
    data.productId = String(productForm?.dataset.productId || data.productId || '');
    data.variantId = selectedVariantId;
    data.productTitle = data.productTitle || document.querySelector('h1')?.textContent?.trim() || document.title.split('|')[0].trim();
    data.productUrl = `${window.location.origin}${productPath}?variant=${selectedVariantId}`;
    data.locale = document.documentElement.lang || data.locale || 'fr';
    const endpoint = form.dataset.endpoint;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'Enregistrement en cours…';
    status.dataset.state = '';

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {'content-type': 'application/json'},
        body: JSON.stringify(data),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.ok) throw new Error(result.message || 'Impossible d’enregistrer votre demande.');
      status.textContent = result.message;
      status.dataset.state = 'success';
      form.querySelector('input[name="email"]').value = '';
    } catch (error) {
      status.textContent = error.message || 'Une erreur est survenue. Réessayez dans quelques instants.';
      status.dataset.state = 'error';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
